import React from "react";
import { useState } from "react";
import { Carousel } from "react-bootstrap";
import "./Banner.css";
import banner1 from "../../../Images/Banner/banner1.jpg";
import banner2 from "../../../Images/Banner/banner2.jpg";
import banner3 from "../../../Images/Banner/banner3.jpg";
import banner4 from "../../../Images/Banner/banner4.jpg";

const Banner = () => {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel activeIndex={index} onSelect={handleSelect} pause={false}>
      <Carousel.Item>
        <img className="d-block w-100 fixed-height" src={banner1} alt="First slide" />
        <Carousel.Caption className="caption rounded-3">
          <h3>Gran Asia</h3>
          <p>When   we  are  Together 
          Life  is  always  Healthy</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100 fixed-height" src={banner2} alt="Second slide" />

        <Carousel.Caption className="caption">
          <h3>Gran Asia</h3>
          <p>When   we  are  Together 
          Life  is  always  Healthy</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100 fixed-height" src={banner3} alt="Third slide" />

        <Carousel.Caption className="caption">
          <h3>Gran Asia</h3>
          <p>When   we  are  Together 
          Life  is  always  Healthy</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <img className="d-block w-100 fixed-height" src={banner4} alt="Third slide" />

      <Carousel.Caption className="caption">
        <h3>Gran Asia</h3>
        <p>When   we  are  Together 
        Life  is  always  Healthy</p>
      </Carousel.Caption>
    </Carousel.Item>
    </Carousel>
  );
};

export default Banner;
